<template>
	<div>
		<h4 class="section-title">Categories</h4>
		<router-link :to="{ name : 'admin.categories.create'}" tag="a" class="button">New category</router-link>
		<div class="table-responsive">
			Showing {{ from }} to {{ to }} of {{ total_rows }}
			<table class="table table-bordered">
				<thead>
					<tr>
						<th class="green-content">Name</th>
						<th class="green-content">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in categories" >
						<td>{{ item.name }}</td>
						<td>
							<router-link :to="{ name: 'admin.categories.detail', params : { id : item.id } }" tag="a" class="button">Show</router-link>
		      				<router-link :to="{ name :'admin.categories.edit', params : { id : item.id } }" tag="a" class="button dark-button">Edit</router-link>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<b-pagination align="right" :total-rows="total_rows" v-model="current_page" :per-page="per_page" @change="setPage">
    	</b-pagination>
	</div>
</template>

<script>
	export default {
		data : function(){
			return {
				current_page : 1,
				total_rows : 15,
				per_page  : 15,
				from : 0,
				to : 0,
				categories : []
			}
		},

		created : function(){
			this.getCategories();
		},

		methods : {

			getCategories : function() {

				var params = {
					filters : {
						page : this.current_page
					}
				}
				
				this.$store.dispatch('getCategories', params).then((res) => {
					this.categories = res.data.data;

					this.current_page = res.data.meta.current_page;
					this.total_rows = res.data.meta.total;
					this.per_page = res.data.meta.per_page;
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				});
			},
			setPage : function(page){
				this.current_page = page;

				this.getCategories();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/categories/AdminCategoryListComponent.vue